<template>
  <v-container fluid style="padding: 0px 0;" fill-height>
    <div v-show="isLoading" style="width: 100%; position: absolute; top: 50%; -webkit-transform: translateY(-50%); -ms-transform: translateY(-50%); transform: translateY(-50%);">
      <v-card
        max-width="150"
        light
        color="rgba(255, 255, 255, 0.7)"
        style="left: 50%; margin-left: -75px;"
      >
        <v-card-text class="text-center">
          <v-progress-circular
            :size="100"
            :width="10"
            color="black"
            indeterminate
          >Loading...</v-progress-circular>
        </v-card-text>
      </v-card>
    </div>
    <v-snackbar v-model="distanceSnack" timeout="5000" top app light>
      Please, frame all your body, you are too far or too near
    </v-snackbar>
    <v-snackbar v-model="notAlreadyVisitedSnackbar" timeout="5000" top app light>
      Welcome, I would like to suggest you to set your sounds in settings for each body's joint.
      Click on "menu icon" and then "Settings"
    </v-snackbar>
    <v-fab-transition>
      <v-btn v-show="!isLoading" fab large :color="FABColor" fixed right bottom @click="FABModel = !FABModel">
          <v-icon>{{FABIcon}}</v-icon>
      </v-btn>
    </v-fab-transition>
    <canvas align="center" id="output" v-show="!isLoading"/>
    <video muted playsinline id="videoElement" style="display: none"></video>
  </v-container>
</template>

<script>
  import '@tensorflow/tfjs-converter';
  import '@tensorflow/tfjs-core';
  const posenet = require('@tensorflow-models/posenet');
  import '@tensorflow/tfjs-backend-webgl';
  export default {
    name: 'PoseEstimation',

    data: () => ({
      nnet: null,
      LINE_WIDTH: 2,
      globalConfidence: 0.7,
      canvasElement: null,
      videoElement: null,
      canvasContext: null,
      deviceWidth: "0px",
      deviceHeight: "0px",
      printFPSDelay: null,
      loadingSteps: {video: false, net: false},
      isLoading: true,
      FABIcon: "play_arrow",
      FABModel: false,
      FABColor: "#1B5E20",
      PoseNetStatus: false,
      distanceSnack: false,
      distanceSnackDelay: null,
      scaleFactor: 0.3,
      notAlreadyVisitedSnackbar: false,
    }),

    mounted: function(){
      this.mountedActions()
      this.$nextTick(()=>{
        if(this.$cookies.isKey("alreadyVisited")){
          this.notAlreadyVisitedSnackbar = !this.$cookies.get("alreadyVisited")
        }else{
          this.notAlreadyVisitedSnackbar = !false
        }
      })
    },

    computed:{
      runningPoseNet(){
        return this.$store.state.runningPoseNet
      },
      setDimensions(){
        return {Height: this.$store.state.appHeight, Width: this.$store.state.appWidth}
      },
    },

    beforeDestroy: function(){
      this.togglePoseNet(false)
    },

    watch:{
      FABModel(newVal){
        if(newVal == true){
          this.FABIcon = "pause"
          this.FABColor = "#D84315"
        }else{
          this.FABIcon = "play_arrow"
          this.FABColor = "#1B5E20"
        }
        this.togglePoseNet(newVal)
      },
      runningPoseNet(newVal){
        this.PoseNetStatus = newVal
      },
      setDimensions(newVal){
         this.setDimensionsMethod(newVal)
      },
      loadingSteps: {
        handler: function (newVal) {
          const def = {video: false, net: false}
          const loaded = {video: true, net: true}
          if(newVal.video === loaded.video && newVal.net === loaded.net){
            this.videoElement.play()
            this.isLoading = false
            this.setSounds()
            this.loadingSteps = def
          }
        },
        deep: true
      },
    },

    methods:{

      async mountedActions(){
        this.canvasElement = document.getElementById('output');
        this.videoElement = document.getElementById("videoElement");
        this.canvasContext = this.canvasElement.getContext('2d');
        this.setDimensionsMethod(this.setDimensions)
        this.$nextTick(async ()=>{
          this.setElementsDimensions()
          this.initPoseNet()
          this.setVideo()
        })
      },

      async setElementsDimensions(){
        this.canvasElement.height = this.deviceHeight
        this.canvasElement.width = this.deviceWidth
        this.videoElement.width = this.deviceWidth * this.scaleFactor
        this.videoElement.height = this.deviceHeight * this.scaleFactor
      },

      setDimensionsMethod(newVal, ){
        this.deviceHeight = newVal.Height
        this.deviceWidth = newVal.Width
        this.setElementsDimensions()
      },

      togglePoseNet(status){
        this.$store.commit("changeRunningPosenet", status)
        this.PoseNetStatus = status
        if(status === true){
          this.getPose()
        }else{
          this.canvasContext.clearRect(0, 0, this.deviceWidth, this.deviceHeight);
        }
      },

      async initPoseNet(){
        this.nnet = await posenet.load(
            {
              architecture: 'MobileNetV1',
              outputStride: 16,
              multiplier: 0.75,
              inputResolution: 257
            }
        );
        this.loadingSteps.net = true
      },

      async setVideo(){
        if(navigator.mediaDevices.getUserMedia) {
          this.videoElement.srcObject = await navigator.mediaDevices.getUserMedia({ video: {facingMode: 'user'}, audio: false })
        }
        this.videoElement.onloadedmetadata = () => {
          this.loadingSteps.video = true
        }
      },

      async estimatePoseOnImage(){
        var beforeTime = new Date()
        const pose = await this.nnet.estimateSinglePose(this.videoElement, {
          flipHorizontal: true
        });
        if(new Date() - this.printFPSDelay > 1000){
          console.log("FPS: ", parseInt(1/((new Date() - beforeTime)/1000)))
          this.printFPSDelay = new Date()
        }
        return pose;
      },

      async getPose(){
        const res = await this.estimatePoseOnImage()
        if(this.isAllBodyFramed(res.keypoints) === true){
          await this.soundPose(res.keypoints)
          this.drawPose(res.keypoints)
        }else{
          if(new Date()-this.distanceSnackDelay > 7000){
            this.distanceSnack = true
            this.distanceSnackDelay = new Date()
          }
        }
        this.drawPose(res.keypoints)
        if(this.PoseNetStatus === true){
          requestAnimationFrame(this.getPose);
        }
      },

      async drawPose(keypoints){
        this.canvasContext.clearRect(0, 0, this.deviceWidth, this.deviceHeight)
        //this.canvasContext.scale(-1,1)
        //this.canvasContext.drawImage(this.videoElement, 0, 0, -this.deviceWidth, this.deviceHeight);
        this.drawSkeleton(keypoints, this.globalConfidence, this.canvasContext, 1/this.scaleFactor)
        this.drawKeypoints(keypoints, this.globalConfidence, this.canvasContext, 1/this.scaleFactor)
      },

      drawSkeleton(keypoints, minConfidence, canvasContext, scale = 1) {
        const adjacentKeyPoints =
            posenet.getAdjacentKeyPoints(keypoints, minConfidence);

        function toTuple({y, x}) {
          return [y, x];
        }

        adjacentKeyPoints.forEach((keypoints) => {
          this.drawSegment(
              toTuple(keypoints[0].position), toTuple(keypoints[1].position), this.$store.state.lineColor,
              scale, canvasContext);
        });
      },

      drawKeypoints(keypoints, minConfidence, canvasContext, scale = 1) {
        for (let i = 0; i < keypoints.length; i++) {
          const keypoint = keypoints[i];

          if (keypoint.score < minConfidence) {
            continue;
          }

          const {y, x} = keypoint.position;
          this.drawPoint(canvasContext, y * scale, x * scale, 3, this.$store.state.lineColor);
        }
      },
      
      drawSegment([ay, ax], [by, bx], color, scale, canvasContext) {
        canvasContext.beginPath();
        canvasContext.moveTo(ax * scale, ay * scale);
        canvasContext.lineTo(bx * scale, by * scale);
        canvasContext.lineWidth = this.LINE_WIDTH;
        canvasContext.strokeStyle = color;
        canvasContext.stroke();
      },

      drawPoint(canvasContext, y, x, r, color) {
        canvasContext.beginPath();
        canvasContext.arc(x, y, r, 0, 2 * Math.PI);
        canvasContext.fillStyle = color;
        canvasContext.fill();
      },

      soundPose(keypoints){
        this.emitSound(keypoints, "rightWrist", "rightShoulder")
        this.emitSound(keypoints, "leftWrist", "leftShoulder")
      },

      emitSound(keypoints, targetP, referenceP, typeLimit = "<"){
        var target = this.getPartPosition(keypoints, targetP, this.globalConfidence)
        var reference = this.getPartPosition(keypoints, referenceP, this.globalConfidence)
        if(this.checkCoords(target) && this.checkCoords(reference)){
          var comparison = target.y < reference.y
          if(typeLimit == ">"){
            comparison = target.y > reference.y
          }
          else if(typeLimit == "=="){
            comparison = target.y == reference.y
          }
          if(comparison){
            let soundPlay = window.createjs.Sound.play(this.$store.getters.getSoundByPart(targetP))
            soundPlay.soundID = this.$store.getters.getSoundByPart(targetP)
            soundPlay.on("complete", this.soundEmitted)
          }
        }
      },

      soundEmitted(evt){
        this.$store.commit("incrementEmitted", evt.currentTarget.soundID)
      },

      setSounds(){
        //dovranno essere registrati tutti i suoni necessari staticamente
        window.createjs.Sound.registerSound(require("@/assets/sounds/tap.mp3"), "s1")
        window.createjs.Sound.registerSound(require("@/assets/sounds/ding.mp3"), "s2")
      },

      isAllBodyFramed(keypoints){
        var framed = 0.0
        var total = parseFloat(keypoints.length)
        for(var index = 0; index < total; index++){
          if(this.checkCoords(keypoints[index].position)){
            framed++
          }
        }
        if(framed/total*100.0 >= 50.0){
          return true
        }
      },

      checkCoords(position){
        if(position.x >= 0 && position.y >= 0 && position.x <= this.deviceWidth && position.y <= this.deviceHeight)
          return true
        else
          return false
      },

      getPartPosition(keypoints, part, minConfidence){
        var position = {x: -999999, y: -999999}
        for(var index = 0; index < keypoints.length; index++){
          if(keypoints[index].part === part){
            if(keypoints[index].score > minConfidence){
              position = keypoints[index].position
              break
            }else{
              break
            }
          }
        }
        return position
      }

    }
  }
</script>
